export default __webpack_public_path__ + "static/media/the_venue_6.dee45cca.png";